export default {
    "business": {
        "": "",
        "orderTrack": "ติดตามคำสั่งขนส่งสินค้า",
        "updateTo": "อัพเดท",
        "exceptionQty": "จำนวนข้อยกเว้น",
        "origin": "เมืองต้นทาง",
        "destination": "เมืองปลายทาง",
        "vehicleTeamName": "กลุ่มยานพาหนะของ",
        "billingItemsName": "รายการเรียกเก็บเงิน",
        "source": "แหล่งที่มา",
        "accidentNumber": "เวลาผิดปกติ",
        "billNumber": "ความถี่",
        "transIndex": "ดัชนี",
        "plateNumber": "หมายเลขป้ายทะเบียน",
        "driverMobile": "เบอร์โทรพนักงานขับรถ",
        "certificateNo": "หมายเลขใบอนุญาต",
        "certificateName": "ประเภทรหัส",
        "stationType": "ประเภทสถานที่",
        "routeQty": "หมายเลขใบตราส่งสินค้า",
        "locationQty": "จำนวนสถานที่",
        "goodsValue": "มูลค่าประกันสินค้า",
        "serviceItemName": "รายการการบริการ",
        "jobDescription": "ตำแหน่งงาน",
        "counactEmail": "อีเมล",
        "createdDt": "เวลารถเริ่มวิ่ง",
        "createdDateTime": "เวลาที่จัดทำ",
        "grade": "ระดับ",
        "carloadQuotation": "บรรทุกเต็มคันรถหรือไม่",
        "billingItemName": "รายการเรียกเก็บเงิน",
        "frequency": "ความถี่",
        "sourceName": "แหล่งข้อมูล",
        "code": "รหัส",
        "invokeParam": "ค่าพารามิเตอร์การทดลอง",
        "ruleCode": "รหัสกฎระเบียบ",
        "templateName": "แบบฟอร์มเอกสารข้อมูลราคา",
        "motherTemplateName": "เทมเพลตเอกสารข้อมูลราคา",
        "lightRatio": "อัตราส่วนปริมาตร/น้ำหนัก",
        "projectName": "สินค้าบริการ",
        "editedDt": "เปลี่ยนเวลา",
        "editorName": "ผู้แก้ไข",
        "lifetimeEnd": "วันหมดอายุ",
        "lifetimeStart": "วันที่มีผลบังคับ",
        "externalContractNo": "หมายเลขติดตามภายนอกสถานที่จัดส่งสินค้า",
        "partnerName": "คู่ค้า",
        "contractNo": "รหัสสัญญา",
        "quoteType": "ประเภทของสัญญา",
        "creatorName": "สร้างโดย",
        "creator": "ผู้สร้างบัญชี",
        "createMode": "ประเภทของการจัดทำ",
        "order": "คำสั่งขนส่งสินค้า",
        "orderNo": "เลขที่ใบสั่งงาน",
        "transportNo": "หมายเลขใบตราส่งสินค้า",
        "transportType": "ประเภทใบนำส่งสินค้า",
        "routeNo": "หมายเลขส่งสินค้า",
        "pickUpRouteNo": "หมายเลขติดตามรถขนส่ง",
        "deliverRouteNo": "หมายเลขรถขนส่ง",
        "originNo": "หมายเลขติดตามต้นทาง",
        "transferNo": "หมายเลขติดตามภายนอก",
        "sequence": "ลำดับ",
        "shipper": "ผู้ส่งสินค้า",
        "goodsBillNo": "จำนวนสินค้า",
        "jobStatus": "สถานะงาน",
        "customerSAPCode": "รหัส SAP ลูกค้า",
        "upstreamTrackingNumber": "หมายเลขติดตามต้นทาง",
        "placeholderPresetLine": "กำหนดเส้นทาง",
        "customerLineCode": "รหัสสายลูกค้า",
        "goodsTypeDescription": "คำอธิบายประเภทรายการ",
        "deliverNo": "คำสั่งขนส่ง",
        "plan": "วางแผน",
        "planNo": "หมายเลขแผน",
        "taskNo": "หมายเลขงาน",
        "bill": "ใบแจ้งหนี้",
        "billNo": "หมายเลขใบเรียกเก็บเงิน",
        "status": "สถานะ",
        "itemTypeSearch": "ประเภทสินค้า, รหัสสินค้า, คีย์เวิร์ด",
        "businessUnit": "หน่วยงาน",
        "porduct": "การขนส่งสินค้า",
        "bizType": "ประเภทธุรกิจ",
        "paperyReceipt": "ต้องการใบเสร็จรับเงินหรือไม่",
        "receiptQty": "จำนวนใบเสร็จรับเงิน",
        "receiptType": "ประเภทใบเสร็จรับเงิน",
        "light": "สินค้าเบา",
        "temperatureControlName": "ประเภทอุณหภูมิ",
        "itemTypeCode": "รหัสประเภทสินค้า",
        "itemType": "ประเภทสินค้า",
        "lowestTemperature": "อุณหภูมิต่ำสุด (℃)",
        "highestTemperature": "อุณหภูมิสูงสุด (℃)",
        "keywords": "คีย์เวิร์ด",
        "createdDate":"วันที่สร้าง",
        "updatedDate":"วันที่อัปเดต",
        "action":"ดำเนินการ",
        "monitorType": "ประเภทอุณหภูมิ",
        "volume": "ปริมาตรรวม (คิวบิกเมตร)",
        "packingQty": "จำนวนบรรจุภัณฑ์ทั้งหมด",
        "numberOfPackages": "จำนวนบรรจุภัณฑ์",
        "numberOfItemPerPackages": "จำนวนสินค้าต่อบรรจุภัณฑ์",
        "isInsurance": "มีประกันสินค้าหรือไม่",
        "tempTypeLimit": "ช่วงการควบคุมอุณหภูมิ",
        "weight": "นำ้หนักรวม (กิโลกรัม)",
        "goodsQty": "จำนวนสินค้าทั้งหมดต่อบรรจุภัณฑ์",
        "vehicleTypeName": "ประเภทรถที่จอง",
        "requestedVehicleType": "รุ่นรถ",
        "actualVehicleType": "รุ่นรถ",
        "goodsDescription": "คำอธิบายประเภทสินค้า",
        "goodsCargoDescription": "คำอธิบายสินค้า",
        "currencyUnit": "สกุลเงิน",
        "thb": "บาท",
        "usDollar": "ยูเอสดอลลาร์",
        "goodsTypeName": "ประเภทสินค้า",
        "goodsTypeNumber": "หมายเลขสินค้า",
        "siteName": "รหัสต้นทาง",
        "siteCodeAndName": "รหัสและชื่อคลัง",
        "siteNameOrigin": "รหัสต้นทาง",
        "siteNameDestination": "รหัสปลายทาง",
        "siteNameOriginToolTip": "รหัสต้นทาง",
        "siteNameDestinationToolTip": "รหัสปลายทาง",
        "addressOriginToolTip": "ที่อยู่",
        "addressDestinationToolTip": "ที่อยู่",
        "contactNumberOriginToolTip": "หมายเลขติดต่อ",
        "contactNumberDestinationToolTip": "หมายเลขติดต่อ",
        "contactNameOriginToolTip": "ชื่อผู้ติดต่อ",
        "contactNameDestinationToolTip": "ชื่อผู้ติดต่อ",
        "provinceOriginToolTip": "จังหวัด เมือง อำเภอ",
        "provinceDestinationToolTip": "จังหวัด เมือง อำเภอ",
        "originSiteCodeAndName": "ข้อมูลสถานที่รับสินค้า",
        "originShipProvince": "จังหวัดต้นทาง",
        "originShipDistrict": "เขต/เมืองต้นทาง",
        "originShipSubDistrict": "อำเภอ/ตำบลต้นทาง",
        "destinationSiteCodeAndName": "ข้อมูลสถานที่ส่งสินค้า",
        "destinationShipDistrict": "เขต/เมืองปลายทาง",
        "destinationShipProvince": "จังหวัดปลายทาง",
        "destinationShipSubDistrict": "อำเภอ/ตำบลปลายทาง",
        "siteNamePlaceholder": "กรุณาเลือกสถานที่",
        "contactMobile": "หมายเลขติดต่อ",
        "contactMobilePlaceholder": "กรุณากรอกหมายเลขโทรศัพท์ติดต่อ",
        "contactName": "ชื่อบุคคลติดต่อ",
        "neededLoading": "ที่จะบรรทุก",
        "provinceCityDistrict": "จังหวัด/เมือง/อำเภอ",
        "addressInfo": "ข้อมูลที่อยู่",
        "originProvince": "จังหวัดต้นทาง",
        "originCity": "เมืองต้นทาง",
        "originDistrict": "อำเภอต้นทาง",
        "startCityDistrict": "เริ่มต้นที่จังหวัด อำเภอ เมือง",
        "latestDeliveryDt": "เวลาเข้ารับ",
        "address": "ที่อยู่",
        "senderAddress": "ที่อยู่จัดส่ง",
        "receiverAddress": "ที่อยู่ผู้รับ",
        "pickupComments": "คำแนะนำในการรับสินค้า",
        "neededUnloading": "มีบริการขนส่ง",
        "latestReceivedDt": "เวลารับสินค้าล่าสุด",
        "deliveryComments": "คำแนะนำในการจัดส่ง",
        "pickupTotalMarkBool": "รายละเอียดสินค้า (กก, คิวบิกเมตร, กล่อง)",
        "packingGoodsDescription": "คำอธิบายสินค้า",
        "itemName": "ชื่อสินค้า",
        "skuCode": "รหัสรายการ",
        "packageWidth": "ความกว้างบรรจุภัณฑ์ (m)",
        "packageHeight": "ความสูงบรรจุภัณฑ์ (m)",
        "packageLength": "ความยาวบรรจุภัณฑ์ (m)",
        "packageWidth2": "ความกว้างบรรจุภัณฑ์",
        "packageHeight2": "ความสูงบรรจุภัณฑ์",
        "packageLength2": "ความยาวบรรจุภัณฑ์",
        "packingUnit": "หน่วยบรรจุภัณฑ์",
        "packingVolume": "ปริมาตรต่อบรรจุภัณฑ์ (คิวบิกเมตร)",
        "packingWeight": "น้ำหนักต่อบรรจุภัณฑ์ (กก.)",
        "packageStandard": "ข้อกำหนดเกี่ยวกับบรรจุภัณฑ์",
        "goodsUnit": "หน่วยของสินค้า",
        "packingCloseQty": "จำนวนบรรจุภัณฑ์",
        "orderType": "ประเภทเอกสาร",
        "checkedPersonName": "ยืนยันบุคคล",
        "createRoute": "สร้างคำสั่งจัดส่ง",
        "senderCity": "เมืองต้นทาง",
        "senderDistrict": "เขตที่จัดส่งสินค้า",
        "receiverCity": "เมืองปลายทาง",
        "receiverDistrict": "เขตที่รับสินค้า",
        "originatingSiteName": "สถานที่ขนส่งสินค้า",
        "destinationSiteName": "สถานที่จัดส่งสินค้า",
        "destinationProvince": "จังหวัดปลายทาง",
        "destinationCity": "เมืองปลายทาง",
        "destinationDistrict": "อำเภอ/เขตปลายทาง",
        "temperatureControl": "การควบคุมอุณหภูมิ",
        "surchargeDiscount": "รายการค่าธรรมเนียม/ส่วนลด",
        "assignVehicleType": " ประเภทรถที่ได้รับมอบหมาย",
        "sameAsRequested": "ประเภทเดียวกับที่จอง ",
        "differentFromRequested": "คนละประเภทกับที่จอง",
        "paidByVehicleType": "จ่ายด้วยรถประเภท",
        "saveJobInformation": "บันทึกข้อมูลเลขที่ใบสั่งงาน",
        "confirmJobInformation": "ยืนยันข้อมูลงาน",
        "doYouWantToSetAllImportedJobInformation":"คุณต้องการตั้งค่าสถานะการตรวจสอบข้อมูลงานที่นำเข้าทั้งหมดเป็น 'ยืนยันแล้ว' หรือไม่ ?",
        "confirmJobInformationWarning":"งานที่ไม่มีเลขที่ใบอ้างอิงขนส่ง จะถูกบันทึกโดยอัตโนมัติเป็น<b>บันทึก</b>ในสถานะการตรวจสอบ",
        "importJobInformationsCheckStatusToConfirm":"นำเข้าข้อมูลงาน และ Check Status สถานะเป็น 'Confirmed'",
        "importJobInformationsCheckStatusToSave":"นำเข้าข้อมูลงาน และ Check Status สถานะเป็น 'Save'",
        "areYouSureYouWantToSaveThisJobInformation": "คุณแน่ใจที่จะบันทึกข้อมูลเลขที่ใบสั่งงานนี้?",
        "savedSuccessfully": "บันทึกข้อมูลสำเร็จ",
        "areYouSureYouWantToConfirm": "หลังจากยืนยัน ข้อมูลเลขที่ใบสั่งงานนี้จะไม่สามารถแก้ไขได้อีก คุณแน่ใจที่จะยืนยัน?",
        "confirmedSuccessfully": "ยืนยันข้อมูลสำเร็จ",
        "actualTotalNumberOfPackagesReceived": "จำนวนบรรจุภัณฑ์ที่ได้รับทั้งหมด",
        "actualTotalNumberOfPackagesPaid": "จำนวนบรรจุภัณฑ์ที่จ่ายทั้งหมด",
        "unit ": "หน่วย",
        "addServiceItem": "เพิ่มรายการค่าธรรมเนียม/ส่วนลด",
        "searchbyDiscountItemNameandCode": "กรุณากรอกรหัสค่าธรรมเนียม/ส่วนลด และ รายการค่าธรรมเนียม/ส่วนลด",
        "pleaseenterDiscountName": "กรุณากรอกรายการค่าธรรมเนียม/ส่วนลด",
        "pleaseenterDiscountItemcode": "กรุณากรอกรหัสค่าธรรมเนียม/ส่วนลด",
        "note": "ข้อมูลเพิ่มเติม",
        "packagingUnit": "หน่วยของบรรจุภัณฑ์",
        "numberOfItemsPerPackages": "จำนวนสินค้าต่อบรรจุภัณฑ์",
        'shippingOrderConfirmation': "การยืนยันใบคำสั่งขนส่งสินค้า",
        'wouldYouLikeToConfirmAllImportedShippingOrders': "คุณต้องการยืนยันที่จะนำเข้าใบคำสั่งขนส่งสินค้าทั้งหมดใช่หรือไม่?",
        'import_ShippingOrder': "Import_Shipping Order",
        "importShippingOrder": "นำเข้าคำสั่งขนส่งสินค้า",
        "backToShippingOrder": "กลับไปยังหน้า SHIPPING ORDER",
        "goToSchedule": "ไปหน้าจัดตาราง",
        'direct_Schedule_Import': "Direct_Schedule_Import Shipping Order",
        "itemWithAnIssueWillNotBeUploadedAndSaveToTheServer": "รายการที่มีปัญหาจะไม่ถูกนำเข้าระบบ กรุณาแก้ไขรายการ และอัพโหลดอีกครั้ง",
        "itemWithAnIssue": "รายการที่มีปัญหา",
        "itemsWithAnIssue": "หลายรายการที่มีปัญหา",
        "startDateAll": "วันเริ่มต้น: ทั้งหมด",
        "endDateAll": "วันสิ้นสุด: ทั้งหมด",
        "schedule": "ตาราง",
        "requiredPickupDate": "ระบุวันเข้ารับ",
        "requiredDeliveryDate": "ระบุวันนำส่ง",
        "downloadTheExcelFileOfTheCurrentSchedule": "ดาวน์โหลดไฟล์ Excel ของ Schedule ปัจจุบัน เพื่อให้คุณสามารถอัปเดตข้อมูลและนำเข้าในขั้นตอนต่อไป",
        "downloadExcelFileToPrepareImportFile": "ดาวโหลดไฟล์ Excel เพื่อนำเข้าไฟล์ ​<br/> ​(กด ดำเนินการต่อ หากดาวน์โหลดไฟล์เรียบร้อยแล้ว)",
        "haveBeenUploadAnInformation": "และข้อมูลได้รับการอัพเดทเรียบร้อบแล้ว",
        "haveBeenUploadAnInformationTrack": "และข้อมูลได้รับการอัพเดทเรียบร้อยแล้ว",
        "haveBeenUploadAnInformationShipping": "และข้อมูลได้รับการอัพเดทเรียบร้อยแล้ว",
        "descriptionUploadSuccess": "ระบบได้นำเข้า FILE_NAME และข้อมูลได้รับการอัพเดทเรียบร้อบแล้ว",
        "backTo": "กลับไปยัง",
        "newSchedule": "ตารางใหม่.ขนาดไฟล์ใหญ่สุดที่รองรับ",
        "licensePlateNumber": "หมายเลขป้ายทะเบียน",
        "revokeTransfer": "ยกเลิกการโอน",
        "routeInfo": "ข้อมูลการจัดส่ง",
        "routeList": "รายการใบตราส่งสินค้า",
        "routeDetail": "ข้อมูลสินค้า",
        "latestBeginTime": "เวลาจัดส่งที่กำหนด",
        "latestEndTime": "เวลาจัดส่งที่กำหนด",
        "routeTransferSave": "การตั้งค่าสถานีโอนคำสั่งจัดส่ง",
        "noNeededPickupSave": "ไม่มีการตั้งค่าจุดโอนการรับสินค้า",
        "noNeededDeliverySave": "ไม่มีการตั้งค่าจุดโอนการจัดส่งสินค้า",
        "pickupTransferSaveHandler": "การตั้งค่าจุดโอนการรับสินค้า",
        "deliveryTransferSaveHandler": "การตั้งค่าจุดโอนการจัดส่งสินค้า",
        "presetLine": "กำหนดเส้นทาง",
        "orderSource": "ที่มาของคำสั่งขนส่ง",
        "receiverUser": "ข้อมูลการติดต่อผู้รับ",
        "workAmount": "ปริมาณธุรกิจ",
        "rangeReceivedDt": "เวลาที่รับสินค้า",
        "vehicleDetail": "ข้อมูลการจัดส่ง",
        "planBeginDt": "เวลาออกเดินทางตามแผน",
        "planEndDt": "เวลาดำเนินการแล้วเสร็จตามแผน",
        "planDeliveryStartTime": "เวลาจัดส่งตามแผน",
        "planEstimatedTime": "เวลาโดยประมาณ",
        "planResidenceTime": "เวลารับมอบโดยประมาณ",
        "estimatedMileage": "ระยะทางสะสมโดยประมาณ",
        "planFullLoadRatio": "อัตราการบรรทุก",
        "planTonKm": "ตัน-กิโลเมตรโดยประมาณ",
        "routeName": "ชื่อเส้นทาง",
        "locationGPS": "ที่ตั้งของที่อยู่",
        "workType": "ประเภทงาน",
        "earliestReceivedDt": " เวลาจัดส่ง",
        "autoLine": "การวางแผนอัตโนมัติ",
        "fixedLine": "ระบุเส้นทางแบบเจาะจง",
        "destinationSite": "ข้อมูลสถานที่ส่งสินค้า",
        "originatingSite": "ข้อมูลสถานที่รับสินค้า",
        "origindistrict": "อำเภอ/เขตต้นทาง",
        "transportOrderDetail": "ข้อมูลคำสั่งขนส่งสินค้า",
        "inBatchesLabel": "อนุญาตให้ดำเนินการแบบกลุ่ม",
        "orderBillingCost": "ค่าใช้จ่ายโดยประมาณ",
        "transportationOrderType": "ประเภทของคำสั่งขนส่งสินค้า",
        "transportDialogTitle": "ข้อมูลการจัดส่งสินค้าอย่างคร่าวๆ",
        "capacityDriver": "ชื่อพนักงานขับรถ",
        "fileName": "ชื่อไฟล์",
        "vehicleTemperature": "อุณหภูมิรถ",
        "routeCarloadQuotation": "ยานพาหนะ",
        "prebookPickupDt": "เวลานัดรับ",
        "dispatcherName": "ผู้ส่ง",
        "transportStatus": "สถานะใบตราส่งสินค้า",
        "transportExPickupScanDt": "เวลาสแกนการรับสินค้า",
        "equipmentNo": "หมายเลขติดตาม",
        "pickupRemarks": "บันทึกการรับสินค้า",
        "actualPackingQty": "จำนวนบรรจุภัณฑ์จริง",
        "actualVolume": "ปริมาตรจริง (ตร.)",
        "actualGoodsQty": "ปริมาณสินค้าที่รับจริง",
        "actualWeight": "น้ำหนักที่รับ (กก.)",
        "pickupEndDt": "เวลารับสินค้าแล้วเสร็จ",
        "pickupBeginDt": "เวลาเริ่มรับสินค้า",
        "pickupArrivalDt": "เวลาที่มาถึงเพื่อรับสินค้า",
        "originalWorkAmount": "ปริมาณภาระงาน",
        "workRecord": "บันทึกภาระงาน",
        "transferType": "ประเภทการขนส่ง",
        "transferCenterNo": "หมายเลขการโอนคำสั่ง",
        "transferSiteName": "สถานที่ขนส่ง",
        "shipperShortName": "ตัวย่อของผู้ขนส่งสินค้า",
        "receivedGoodsTemperature": "อุณหภูมิการรับสินค้าเป็นองศาเซลเซียส",
        "pickupedGoodsTemperature": "อุณหภูมิการจัดส่งสินค้าเป็นองศาเซลเซียส",
        "toVoid": "เป็นโมฆะ",
        "reCcollectGoods": "รับใหม่",
        "transferBill": "คำสั่งโอน",
        "deliveryDt": "เวลาจัดส่ง",
        "affixedCodeType": "ประเภทฉลาก",
        "deliveryPackingQty": "จำนวนบรรจุภัณฑ์จริง",
        "receivablePackingQty": "จำนวนบรรจุภัณฑ์ที่สามารถรับได้",
        "receiptPackingQty": "จำนวนบรรจุภัณฑ์ที่ได้รับ",
        "receivableWeight": "น้ำหนักที่สามารถรับได้ (กก.)",
        "receivableVolume": "ปริมาตรที่สามารถรับได้ (ตาราง)",
        "receiptWeight": "น้ำหนักจริง (กก.)",
        "receiptVolume": "ปริมาตรจริง (ตร.)",
        "deliverPackingQty": "จำนวนบรรจุภัณฑ์ที่จะจัดส่ง",
        "damagedPackingQty": "หีบที่เสียหาย",
        "occurrenceTime": "เวลาที่จัดทำ",
        "exceptionNo": "หมายเลขข้อยกเว้น",
        "exceptionType": "ประเภทข้อยกเว้น",
        "exceptionDescription": "ข้อมูลข้อยกเว้น",
        "transportExDeliveryEndDt": "เวลาที่จัดส่งแล้วเสร็จ",
        "executeStatus": "สถานะการดำเนินการ",
        "actualMileage": "ระยะทางตามจริง",
        "transportExDeliveryScanDt": "เวลาสแกนการจัดส่ง",
        "totalGoodsQty": "ปริมาณทั้งหมด",
        "totalPackingQty": "จำนวนบรรจุภัณฑ์ทั้งหมด",
        "missedPackingQty": "จำนวนบรรจุภัณฑ์ที่สูญหาย",
        "rejectedPackingQty": "จำนวนบรรจุภัณฑ์ที่ถูกปฏิเสธ",
        "missedGoodsQty": "ปริมาณที่สูญหาย",
        "damagedGoodsQty": "ปริมาณสินค้าที่เสียหาย",
        "rejectedGoodsQty": "ปริมาณที่ถูกปฏิเสธ",
        "receiptGoodsQty": "จำนวนสินค้าที่ได้รับ",
        "deliveryBeginDt": "เวลาเริ่มรับสินค้า",
        "deliveryArrivalDt": "เวลาจัดส่ง",
        "prebookDeliveryDt": "จองเวลาจัดส่ง",
        "vehicleTypeNameOfWork": "ประเภทรถที่วิ่งจริง",
        "reasonForDifferentVehicle": "เหตุผลสำหรับยานพาหนะที่แตกต่างกัน",
        "reasonOfPaidByVehicleType": "เหตุผลของการชำระเงินตามประเภทของยานพาหนะ",
        "vehicleArrivalDt": "เวลาที่ยานพาหนะมาถึง",
        "dispatchingDt": "กำหนดเวลา",
        "curTime": "เวลาที่เกิดเหตุการณ์",
        "handleTime": "เวลาประมวลผล",
        "confirmTime": "เวลายืนยัน",
        "confirmPerson": "ยืนยันบุคคล",
        "personLiable": "ผู้รับผิดชอบ",
        "rejectedTreatmentMethod": "วิธีจัดการการปฏิเสธ",
        "signPersonDt": "เวลายื่น",
        "taskInfo": "ข้อมูลภารกิจ",
        "requiredReceipt": "จำเป็นต้องมีใบเสร็จรับเงินในรูปแบบเอกสาร",
        "mobile": "โทรศัพท์มือถือ",
        "emailSubject": "หัวข้อของอีเมล",
        "neededPickup": "จำเป็นต้องไปรับของ",
        "neededDelivery": "จำเป็นต้องจัดส่งของ",
        "vehicleTypeAndNumber": "รุ่น*จำนวนยานพาหนะ",
        "batchCode": "กลุ่ม",
        "planRouterTips": "ใบตราส่งสินค้านี้อยู่ในใบตราส่งสินค้าปัจจุบัน กรุณาเลือกใบตราส่งสินค้าฉบับอื่น",
        "reportDataErrTips": "มีข้อผิดพลาดในข้อมูลรายงาน กรุณาปรับปรุงข้อมูลรายงานก่อน",
        "gpsDataLoadingTips": "กำลังรีเฟรชข้อมูลการติดตาม กรุณาตรวจสอบอีกครั้งในภายหลัง",
        "orderCreatorName": "ชื่อผู้จัดทำคำสั่ง",
        "noteTakerName": "ชื่อผู้บันทึก",
        "shipmentStatus": "สถานะใบตราส่งสินค้า",
        // tuan
        "jobNumber": "เลขที่ใบสั่งงาน",
        "jobNumbers": "เลขที่ใบสั่งงาน",
        "subContractor": "ผู้ขนส่ง",
        "vendorSAP": "รหัส SAP ผู้ประกอบการขนส่ง",
        "childRtoWSL": "เลขที่ใบสั่งงานส่ง WSL",
        "driverName": "ชื่อพนักงานขับรถ",
        "driverLicenseNumber": "หมายเลขใบอนุญาต",
        "contactNumber": "เบอร์ติดต่อ",
        "provinceDistrictSub_District": "จังหวัด, เมือง, เขต/อำเภอ",
        "keyContactPerson": "ชื่อผู้ติดต่อ",
        "keyContactNumber": "หมายเลขผู้ติดต่อ",
        "estimateArriveStationDt": "เวลาถึงจุดหมายโดยประมาณ",
        "estimateLeaveStationDt": "เวลาออกเดินทางโดยประมาณ",
        "transitdialogInMark": "คำแนะนำการขนส่งขาเข้า",
        "transitdialogOutMark": "คำแนะนำการขนส่งขาออก",
        "surchargeDiscount": "ค่าธรรมเนียม/ส่วนลด",
        "surchargeDiscountGroup": "กลุ่มค่าธรรมเนียม/\nส่วนลด",
        "surchargeDiscountCode": "รหัสค่าธรรมเนียม/ส่วนลด",
        "surchargeDiscountName": "รายการค่าธรรมเนียม/ส่วนลด",
        "routeCode": "รหัสเส้นทาง",
        "destinationType": "ประเภทปลายทาง",
        "wslWarehouse": "คลังสินค้า WSL",
        "pleaseSelectWarehouse": "กรุณาเลือกคลังสินค้า",
        "zoneExt": "โซน",
        "routeExt": "เส้นทาง",
        "vehiclePlateNumber": "เลขทะเบียนรถ",
        "licensePlateNumber": "ทะเบียนรถ",
        "provincialSign": "ป้ายจังหวัด",
        "totalWaybillNumber": "หมายเลขใบตราส่งสินค้า",
        "actualPickupTime": "เวลาเข้ารับจริง",
        "actualDeliveryTime": "เวลาจัดส่งจริง",
        "totalVolumes": "ปริมาตร (ลูกบาศก์เมตร)",
        "actualTotalVolume": "ปริมาตรจริง (ลูกบาศก์เมตร)",
        "actualTotalWeight": "น้ำหนักบรรจุต่อห่อจริง (กก.)",
        "actualTotalNumberOfPackages": "จำนวนบรรจุภัณฑ์จริงทั้งหมด",
        "actualTotalNumberOfItems": "จำนวนสินค้าจริงทั้งหมด",
        "assignBy": "กระจายงานโดย",
        "actualReceived": "จำนวนเก็บจริง",
        "actualReceivedUnit": "หน่วยเก็บจริง",
        "actualPaid": "จำนวนจ่ายจริง",
        "actualPaidUnit": "หน่วยจ่ายจริง",
        "saveBy": "บันทึกโดย",
        "updatedDateTime": "วันเวลาที่บันทึก",
        "confirmBy": "ยืนยันโดย",
        "confirmDateTime": "วันเวลาที่ยืนยัน",
        "reconciliationStatus": "สถานะตรวจสอบ",
        "checkStatus": "เช็คสถานะ",
        "scheduleTimeStart": "เวลาที่กระจายงาน",
        "finish": "สำเร็จ",
        "targetPickUpTimeStart": "เวลาเข้ารับ",
        "targetDeliveryTimeStart": "เวลาจัดส่ง",
        "actualPickUpTimeStart": "เวลาเข้ารับจริง",
        "actualDeliveryTimeStart": "เวลาจัดส่งจริง",
        "jobInformation": "ข้อมูลงาน",
        "importExcelFile": "ดาวน์โหลดไฟล์ Excel เพื่อเตรียมสำหรับการนำเข้า <br/> (กด Continue หากดาวน์โหลดไฟล์ Excel เรียบร้อย)",
        "importExcelFileRoad": "ดาวน์โหลดไฟล์ <br/> (กดดำเนินการต่อ ในกรณีที่คุณมีไฟล์อยู่แล้ว)",
        "downloadFileJobDelivered": "ดาวน์โหลดไฟล์เฉพาะสถานะ \"Job_delivered\" เท่านั้น",
        "actualPickupDate": "เวลารับของจริง",
        "actualDeliveryDate": "เวลาส่งของจริง",
        "fromAll": "จาก",
        "toAll": "ถึง",
        "clickToDownload": "ดาวน์โหลด",
        "continue": "ดำเนินการต่อ",
        "cancel": "ยกเลิก",
        "operate": "ดำเนินการ",
        "statuses": "สถานะงาน",
        "clickOrDragFile": "คลิกหรือลากไฟล์มาวาง เพื่อทำการนำเข้า",
        "pleaseUpload": "กรุณาอัปโหลดไฟล์ .xls หรือ .xlsx สำหรับการนำเข้าข้อมูล",
        "allowFileSize": "ขนาดไฟล์สูงสุด",
        "totalFileSize": "ขนาดไฟล์ทั้งหมด",
        "clickToUpload": "คลิกเพื่ออัพโหลด",
        "back": "กลับ",
        "backTo": "กลับสู่หน้า",
        "confirm": "ยืนยัน",
        "quitImport": "ยกเลิกการนำเข้า",
        "confirmQuitImport": "คุณยืนยันที่จะยกเลิกการนำเข้านี้",
        "unableToImport": "นำเข้าไฟล์ไม่สำเร็จ",
        "foundItems": "พบรายการมีปัญหา",
        "pleaseSolve": "โปรดตรวจสอบไฟล์และนำเข้าไฟล์ใหม่อีกครั้ง",
        "unableToImportShipping": "ไม่สามารถนำเข้าไฟล์ได้",
        "foundItemsShipping": "ตรวจพบรายการที่มีปัญหาใน",
        "pleaseSolveShipping": "กรุณาแก้ไขรายการ และอัพโหลดอีกครั้ง",
        "itemsUpdatedShipping": "รายการได้รับการอัพเดทเรียบร้อยแล้ว",
        "itemsIssueShipping": "มีรายการที่มีปัญหา",
        "anIssues": "ที่มีปัญหา",
        "anUpdated": "ได้รับการปรับปรุง",
        "itemsWithoutIssue": "รายการไม่มีปัญหา",
        "itemWithoutIssue": "รายการไม่มีปัญหา",
        "itemsWithoutIssueTrack": "รายการที่สำเร็จ",
        "itemWithoutIssueTrack": "รายการที่สำเร็จ",
        "haveBeenUpload": "ได้รับการอัปโหลดและข้อมูล",
        "itemUpdated": "รายการได้รับการอัพเดทเรียบร้อยแล้ว",
        "itemsUpdated": "รายการได้รับการอัพเดทเรียบร้อยแล้ว",
        "issuesItem": "มีรายการที่มีปัญหา",
        "issuesItems": "มีรายการที่มีปัญหา",
        "notUploadedAndSave": "รายการนี้จะไม่ถูกนำเข้าสู่ระบบ",
        "itemIssue": "รายการที่มีปัญหาจะไม่ถูกนำเข้าระบบ กรุณาแก้ไขรายการ และอัพโหลดอีกครั้ง",
        "itemWithAnIssueShipping": "รายการที่มีปัญหาจะไม่ถูกนำเข้าระบบ กรุณาแก้ไขรายการ และอัพโหลดอีกครั้ง",
        "download": "ดาวน์โหลด",
        "reuploadFile": "นำเข้าไฟล์ใหม่",
        "reuploadFileShipping": "อัพโหลดอีกครั้ง",
        "importSuccessfully": "นำเข้าไฟล์สำเร็จ",
        "actualCargo": "ข้อมูลสินค้าจริง",
        "actualCargoDetail": "รายละเอียดข้อมูลสินค้าจริง (กิโลกรัม, คิวบิกเมตร, กล่อง)",
        "fileTitle": "ระบบได้นำเข้า",
        "targetUpTime": "เวลาเข้ารับ",
        "weightPerPackage": "น้ำหนักต่อบรรจุภัณฑ์ (กก.)",
        "volumeCubicMeter": "ปริมาตร (คิวบิกเมตร)",
        "quantity": "จำนวน",
        "doRef": "เลขที่อ้างอิงใบขนส่ง",
        "farthestStoreCode": "รหัสร้านไกลสุด",
        "invoiceDate": "วันที่ในใบแจ้งหนี้",
        "siteInformaion": "ข้อมูลสถานที่",
        "serveVehicleType": "รองรับประเภทรถ",
        "trip1":"เที่ยว/001",
        "ton2":"ตัน/002",
        "volume3":"ปริมาตร/003",
        "bag4":"ถุง/004",
        "box5":"กล่อง/005",
        "pack6":"ห่อ/006",
        "basket7":"ตะกร้า/007",
        "pallet8":"พาเลท/008",
        "drop9":"จุดส่ง/009",
        "crate10":"ลัง/010",
        "piece11":"ชิ้น/011",
        "kg12":"กิโลกรัม/012",
        "km13":"กิโลเมตร/013",
        "trailerType": "ประเภทหางลาก",
        "trailerPlateNumber": "ทะเบียนหาง",
        "trailerProvincialSign": "ป้ายจังหวัด",
        "trip1":"เที่ยว/001",
        "ton2":"ตัน/002",
        "volume3":"ปริมาตร/003",
        "bag4":"ถุง/004",
        "box5":"กล่อง/005",
        "pack6":"ห่อ/006",
        "basket7":"ตะกร้า/007",
        "pallet8":"พาเลท/008",
        "drop9":"จุดส่ง/009",
        "crate10":"ลัง/010",
        "piece11":"ชิ้น/011",
        "kg12":"กิโลกรัม/012",
        "km13":"กิโลเมตร/013",
        "removeItemTypeSuccess": "ลบประเภทสินค้าแล้ว",
        "cash": "เงินสด",
        "trueMoney": "ทรูมันนี่",
        "qrCode": "คิวอาร์ โค้ด",
        "sequence": "ลำดับการจัดส่ง",
        "confirm_document_status":"สถานะการตรวจสอบเอกสาร",
        "document_confirmed_by":"ตรวจสอบเอกสารโดย" ,
        "document_confirmed_date_time": "วันเวลาที่ตรวจสอบเอกสาร",
        "verified" : "ตรวจสอบแล้ว",
        "unverified" : "ยังไม่ได้ตรวจสอบ",
        "no_data" : "ไม่มีข้อมูล",
        "total_assigned_driver" : "จำนวนคนขับ",
        "addRecord": "เพิ่มบันทึกข้อมูล",
        "areYouSureYouWantToAddRecord": "ยืนยันการเพิ่มบันทึกข้อมูลหรือไม่",
        "recordHaveBeenAdded": "เพิ่มบันทึกข้อมูลแล้ว",
        "pleaseSearchViewData": "กรุณาค้นหาเพื่อดูข้อมูล",
        "selectChildRtoThisPrimaryR":"เลือกเลขที่ใบสั่งงานส่ง WSL",
        "primaryR": "เลขที่ใบสั่งงานหลัก",
        "sendToWSL":"สถานะส่ง WSL",
        "actualWSLProcessTime":"เวลาที่ WSL ประมวลผลจริง",
        "errorFromWSL":"ข้อผิดพลาดจาก WSL"
    },
    "commonTips": {
        "sequenceNoPlaceholder": "กรุณากรอกลำดับการจัดส่ง",
        "pleaseSelectTheKeyContactPerson": "กรุณากรอกชื่อผู้ติดต่อ",
        "pleaseSelectTheKeyContactName": "กรุณากรอกหมายเลขผู้ติดต่อ",
        "placeholderTransitdialogInMark": "กรุณากรอกคำแนะนำการขนส่งขาเข้า",
        "placeholderTransitdialogOutMark": "กรุณากรอกคำแนะนำการขนส่งขาออก",
        "pleaseSelectSiteCodeName": "กรุณาเลือกรหัสและชื่อคลัง",
        "pleaseEnterProvinceDistrictSub_District": "กรุณากรอกจังหวัด, เมือง, เขต/อำเภอ",
        "enterEstimatedArrivalTime": "กรุณากรอกเวลาถึงโดยประมาณ",
        "enterEstimatedDepartureTime": "กรุณากรอกเวลาออกเดินทางโดยประมาณ",
        "pleaseEnterDoRef": "กรุณากรอกเลขที่อ้างอิงใบขนส่ง",
        "pleaseSelectSurchargeDiscount": "กรุณาเลือกกลุ่มค่าธรรมเนียม/ส่วนลด",
        "selectUnit": "กรุณาเลือกหน่วย",
        "pleaseEnterReason": "เหตุผลที่เปลี่ยนประเภทรถ",
        "pleaseSelectDestinationType": "กรุณาเลือกประเภทปลายทาง",
        "pleaseSelectRouteCode": "กรุณากรอกรหัสเส้นทาง",
        "pleaseSelectFarthestStoreCode": "กรุณาเลือกรหัสร้านไกลสุด",
        "billingTipsValidata": "กรุณากรอกคำชี้แจงเหตุผลภายใน 2 ถึง 100 คำ",
        "billingTipsContent": "คำชี้แจงเหตุผล (ต้องกรอก จำกัดไม่เกิน 100 คำ)",
        "attachmentParameterErrorTips": "ค่าพารามิเตอร์เอกสารแนบไม่ถูกต้อง กรุณาปิดหน้าป๊อปอัพแล้วลองอีกครั้ง!",
        "vehicleTypeNameTips": "กรุณากรอกรุ่นรถ",
        "timeRangeTips": "เลือกช่วงเวลา",
        "enterInfoTips": "กรุณากรอกข้อมูลที่จำเป็นก่อนเพิ่มรายการถัดไป",
        "creatorNameTips": "กรุณากรอกผู้จัดทำ",
        "tempRangeTips": "อุณหภูมิต่ำสุดต้องน้อยกว่าค่าสูงสุด!",
        "businessPartnerTips": "กรุณากรอกคู่ค้าทางธุรกิจ",
        "refuseTips": "ท่านแน่ใจว่าจะปฏิเสธหรือไม่?",
        "mustExcelFileTips": "ต้องเป็นไฟล์ excel แนะนำให้ดาวน์โหลดเทมเพลตก่อนกรอกข้อมูล!",
        "inputRequired": "จำเป็น",
        "selectRequired": "จำเป็น",
        "partnerNameTips": "กรุณาเลือกคู่ค้า",
        "ruleCodeTips": "กรุณากรอกรหัสกฎระเบียบ (สูงสุด 32 ตัวอักษร)",
        "ruleTips": "กรุณากรอกชื่อกฎระเบียบ (สูงสุด 32 อักขระ)",
        "max250": "(สูงสุด 250 ตัวอักษร)",
        "max500": "(สูงสุด 500 ตัวอักษร)",
        "importInformationTips": "นำเข้าข้อมูลบ่งชี้",
        "copyAndPasteTips": "คัดลอกสำเร็จ และขณะนี้ ท่านสามารถวางใน excel หรือโปรแกรมแก้ไขข้อความเพื่อใช้อ้างอิง",
        "uploadingTips": "กำลังอัพโหลด",
        "fileSupportTypeTips": "เลือกไฟล์ (รองรับเฉพาะ xls หรือ xlsx)",
        "confirmOperation": "ยืนยันการดำเนินการหรือไม่?",
        "areYouSureToDelete": "ยืนยันการลบหรือไม่?",
        "pleaseSelectProjectName": "กรุณาเลือกรายการ",
        "max100": "(สูงสุด 100 ตัวอักษร)",
        "pleaseInputRemark": "กรุณากรอกคำอธิบาย",
        "pleaseSelectDate": "กรุณาเลือกวันที่",
        "multipleTips": "ตัวเลือกแบบปรนัย",
        "cancelRouteTransferTips": "ยกเลิกการโอนต่อไปหรือไม่",
        "workAmountTips": "กรุณากรอกปริมาณธุรกิจ",
        "contactNameTips": "กรุณากรอกชื่อผู้ติดต่อ",
        "addressTips": "อนุญาตให้เลือกที่อยู่ที่ได้ระบุไว้ (ต้องกรอก)",
        "contactMobileTips": "กรุณากรอกหมายเลขผู้ติดต่อ",
        "pleaseSelectSiteName": "กรุณากรอกรหัสและชื่อคลังสินค้า",
        "pleaseSelectVehicleType": "กรุณาเลือกประเภทรถ",
        "cargoOwnerTips": "กรุณากรอกผู้ส่ง",
        "revokeSucceededTips": "เพิกถอนการยืนยันสำเร็จ!",
        "pushTips": "เลือกบัญชี tms ต้นทาง",
        "pleaseInputRouteNo": "กรุณากรอกหมายเลขการจัดส่ง",
        "sendSuccess": "ส่งสำเร็จ",
        "routeNoIdNotNullTips": "ไม่สามารถลบหมายเลขการจัดส่ง",
        "waybillNoSaveSucceessTips": "บันทึกลำดับใบตราส่งสินค้าแล้ว!",
        "pleaseInputCarrier": "กรุณากรอกผู้ขนส่ง",
        "pleaseInputSubcontractor": "กรุณากรอกผู้ขนส่ง",
        "receiveDatasTips": "ไม่มีใบแจ้งหนี้",
        "removeRouteTips": "ท่านแน่ใจว่าต้องการลบใบตราส่งสินค้าทั้งหมดภายใต้เครื่องหมายวรรคตอนหรือไม่",
        "routerSuccessTips": "ยืนยันการสั่งซื้อจัดส่งสำเร็จ",
        "senderAddressStationIdTips": "กรุณากรอกที่อยู่สำหรับจัดส่งหรือเลือกสถานที่",
        "senderCityTips": "กรุณากรอกเมืองที่จัดส่ง",
        "pleaseInputTransportNo": "กรุณากรอกหมายเลขติดตาม",
        "capacityTypeCodeTips": "กรุณากรอกรุ่น!",
        "capacityDriverMobileTips": "กรุณากรอกหมายเลขโทรศัพท์ของพนักงานขับรถ!",
        "capacityPlateNoTips": "กรุณากรอกหมายเลขป้ายทะเบียน!",
        "capacityDriverTips": "กรุณากรอกพนักงานขับรถ!",
        "capacityIdentificationTips": "กรุณากรอกหมายเลขพนักงานขับรถของท่าน!",
        "transferBillTips": "กรุณากรอกหมายเลขคำสั่งโอน!",
        "pleaseSelectTransferBill": "กรุณาเลือกคำสั่งโอน!",
        "pleaseConfirmGoods": "กรุณายืนยันว่าสินค้าถูกส่งคืนไปยังสถานที่เก็บเดิมแล้ว!",
        "waybillNoNotNullTips": "ไม่สามารถลบหมายเลขติดตาม!",
        "expressNoTips": "รูปแบบหมายเลขติดตามไม่ถูกต้อง!",
        "isConfirmReceipt": "ท่านต้องการยืนยัน ePOD หรือไม่",
        "isConfirmPOD": "คุณต้องการยืนยัน EPOD และ/หรือ POD ใช่หรือไม่?",
        "dataCorrectionWarn": 'กรุณาตรวจสอบและยืนยันข้อมูลใน Data Correction',
        "reminder": "คำเตือน",
        "isConfirmPaperReceipt": "ยืนยัน POD หรือไม่",
        "isConfirmReceiptTips": "ท่านต้องการยืนยันการรับหรือไม่?",
        "backConfirmDt": "กรุณาเลือกเวลารับใบเสร็จรับเงิน",
        "mobileNumberFormatError": "รูปแบบโทรศัพท์ไม่ถูกต้อง",
        "mobileNumberExist": "มีหมายเลขโทรศัพท์แล้ว",
        "emailFormatError": "รูปแบบอีเมล์ไม่ถูกต้อง",
        "emailExist": "มีที่อยู่อีเมล์นี้แล้ว",
        "mobileTotalLengthError": "ความยาวทั้งหมดของหมายเลขโทรศัพท์มือถือที่กรอกต้องไม่เกิน 500",
        "isConfirmReanalyze": "ท่านต้องการยืนยันใบเรียกเก็บเงินนี้อีกครั้งหรือไม่?",
        "transportProductError": "สินค้าฝากขายไม่ถูกต้องและไม่สามารถซิงโครไนซ์ได้!",
        "ownCarOrIndividualDriverNoTransportProduct": "ไม่ได้ทำเครื่องหมายถูกหน้าข้อมูลผลิตภัณฑ์/รายการสำหรับรถยนต์ของตนเองหรือพนักงานขับรถ!",
        "reanalyzeBillSuccess": "คำนวณบิลใหม่สำเร็จ!",
        "insuranceValueMustGreaterThanZero": "เมื่อมูลค่าเอาประกันคือ 'Y' มูลค่าที่แจ้งต้องมากกว่า 0!",
        "pleaseSelectOneMessage": "กรุณาเลือกอย่างน้อยหนึ่งข้อความ!",
        "cancelTransitSuccess": "การโอนถูกยกเลิกสำเร็จ!",
        "transitSuccess": "โอนคำสั่งจัดส่งสำเร็จ!",
        "isAddSamePickupAddressWaybill": "ท่านต้องการเพิ่มใบตราส่งสินค้าที่มีสถานที่จัดส่งเดียวกันในรายการจัดส่งหรือไม่?",
        "isFixedRoute": "การดำเนินการนี้จะแก้ไขบรรทัดข้อมูลภายใต้เงื่อนไขตัวกรองปัจจุบัน ท่านต้องการดำเนินการต่อไปหรือไม่?",
        "pleaseSelectTransitBill": "กรุณาเลือกคำสั่งจัดส่ง (อนุญาตให้ใช้คำสั่งจัดส่งหนึ่งรายการเท่านั้น)",
        "transitBillStatusMustNotClosedOrFinished": "สถานะของคำสั่งจัดส่งต้องเป็นสถานะยังไม่ปิดและยังไม่เสร็จสมบูรณ์",
        "waybillAppendSuccess": "เพิ่มใบตราส่งสินค้าสำเร็จ",
        "replanOnlyNewOrUndispatchTransitBill": "การวางแผนใหม่สามารถเป็นคำสั่งจัดส่งที่สถานะใหม่หรือยังไม่ได้กำหนดเท่านั้น!",
        "isContinueReplan": "ท่านต้องการกำหนดเวลาการดำเนินการใหม่ต่อไปหรือไม่?",
        "emailAddressLengthMustLessThan500": "ความยาวทั้งหมดของที่อยู่อีเมล์ที่กรอกต้องไม่เกิน 500",
        "pleaseSelectGroupFieldOrStatisticField": "กรุณาเลือกช่องกรอกข้อมูลการจัดกลุ่มหรือช่องกรอกข้อมูลสถิติก่อน!",
        "pleaseSelectField": "กรุณาเลือกช่องกรอกข้อมูล!",
        "pleaseSelectReportType": "กรุณาเลือกประเภทรายงาน!",
        "pleaseSelectTimeRange": "กรุณาเลือกกรอบเวลา!",
        "reportIsGenerating": "กำลังจัดทำรายงาน!",
        "dateRangeMustLessThan61Days": "ช่วงวันที่ต้องไม่เกิน 61 วัน!",
        "uploadImageOnlyJpgPngJpegBmp": "รูปภาพที่อัพโหลดต้องเป็นไฟล์ jpg, png, jpeg, bmp เท่านั้น!",
        "uploadImageSizeMustLessThan2Mb": "ขนาดภาพที่อัพโหลดต้องไม่เกิน 2MB!",
        "noFileToDownload": "ไม่มีเอกสารแนบ ไม่ต้องแพ็คและดาวน์โหลด!",
        "trackingDataIsRefreshing": "กำลังรีเฟรชข้อมูลการติดตาม กรุณาตรวจสอบอีกครั้งในภายหลัง!",
        "pleaseSelectBusiness":"กรุณาเลือกประเถทธุรกิจ"
    },
    "error": {
        "validatorError": "ท่านพิมพ์ผิด กรุณาแก้ไข!",
        "errorMsg": "ข้อความแจ้งความผิดพลาด",
        "errorMsgData": "ข้อมูลที่จำเป็นตกหล่น กรุณารีเฟรชหน้าแล้วลองอีกครั้ง!",
        "dataLoadError": "ข้อยกเว้นการโหลดข้อมูล",
        "requireBusinessUnit": "จำเป็นต้องระบุหน่วยงาน",
        "validationNumberHighMax": "กรุณากรอกค่ามากกว่า {x} ถึง {y}",
        "validationNumberHighLow": "กรุณากรอกค่าไม่ต่ำกว่า {x} และไม่สูงกว่า {y}",
    },
    "public": {
        'areYouSureYouWantToQuitImporting': 'คุณแน่ใจหรือไม่ที่ต้องการยกเลิกการนำเข้าไฟล์?',
        'quitImporting': 'ยกเลิกการนำเข้า',
        'downloadTemplateMDT': 'ดาวน์โหลดเทมแพลต',
        'downloadTemplate': 'ดาวน์โหลดเทมแพลต',
        'chooseFile': 'กรุณาเลือกไฟล์เทมแพลต',
        'download1': 'ดาวน์โหลด',
        'theMaximumAllowFileSizeIs': "ขนาดไฟล์ใหญ่สุดที่อนุญาต คือ",
        "totalFileSize": "ขนาดไฟล์ทั้งหมด",
        'onlyFileFormatIsSupported': "รูปแบบไฟล์ที่รองรับ .xls หรือ .xlsx",
        'supportedFileFormat': "รูปแบบไฟล์ที่รองรับ {x}",
        'maxAllowRowText': "จำนวนสูงสุดที่อนุญาต : {x} แถว",
        'notSupportFileType': "ประเภทไฟล์ที่เลือกไม่ถูกต้อง กรุณาตรวจสอบไฟล์",
        "clickOrDragFileToUploadShipping": "คลิก หรือ ลากไฟล์มาบริเวณนี้ เพื่ออัพโหลด",
        "dragOrClickToUpload": "ลากไฟล์มาวางที่นี่หรือกดปุ่มด้านล่าง",
        "dragFileOrClick": "ลากไฟล์มาวางที่นี่หรือกดปุ่มด้านล่าง",
        "dayText": "วัน",
        "download": "ดาวน์โหลด",
        "name": "ชื่อ",
        "have": "เป็นของตนเอง",
        "loading": "กำลังโหลด",
        "distribution": "เมืองที่จัดส่งสินค้า",
        "confirmed": "ยืนยัน",
        "endDate": "วันที่สิ้นสุด",
        "startDate": "วันที่เริ่มต้น",
        "edit": "แก้ไข",
        "vehicleInfo": "ข้อมูลยานพาหนะ",
        "saving": "กำลังบันทึก...",
        "serviceInfo": "ข้อมูลบริการ",
        "qicq": "คิวคิว",
        "wechat": "วีแชท",
        "male": "ชาย",
        "female": "หญิง",
        "userGender": "เพศ",
        "remove": "ลบ",
        "validityRange": "ช่วงความมีผลใช้ได้",
        "provincCityDistrict": "จังหวัด เมือง เเละอำเภอ",
        "siteInfo": "ข้อมูลสถานที่",
        "businessPartner": "คู่ค้าทางธุรกิจ",
        "suspend": "หยุดชั่วคราว",
        "attribute": "คุณลักษณะ",
        "operationLog": "บันทึกการดำเนินงาน",
        "personnelInfo": "ข้อมูลบุคลากร",
        "carrier": "ผู้ขนส่ง",
        "partnerAddName": "ชื่อคู่ค้า",
        "baseInfo": "ข้อมูลพื้นฐาน",
        "refuse": "ปฏิเสธ",
        "agree": "ยอมรับ",
        "acceptJobs": "รับงาน",
        "postalAddress": "ที่อยู่ทางไปรษณีย์",
        "offline": "ออฟไลน์",
        "online": "ออนไลน์",
        "shortName": "ชื่อย่อ",
        "lineNo": "หมายเลขเส้นทาง",
        "importSuccess": "นำเข้าสำเร็จ",
        "no": "ไม่",
        "yes": "ใช่",
        "pod": "หลักฐานการนำส่งสินค้า",
        "epod": "หลักฐานการนำส่งสินค้าแบบอิเล็กทรอนิกส์",
        "all": "ทุกประเภท",
        "sequencing": "ลำดับ",
        "shareRule": "กฎระเบียบเกี่ยวกับการจัดสรร",
        "disableSuccess": "ปิดการใช้งานสำเร็จ",
        "enableSuccess": "เปิดใช้งานสำเร็จ",
        "enableTips": "ท่านแน่ใจว่าจะเปิดใช้งานหรือไม่?",
        "uploadFail": "อัพโหลดไม่สำเร็จ",
        "uploadSuccess": "อัพโหลดสำเร็จ",
        "submitTips": "ท่านแน่ใจว่าจะยื่นหรือไม่?",
        "submitSuccess": "ยื่นสำเร็จ",
        "copyAll": "คัดลอกข้อมูลทั้งหมด",
        "uploadTemplate": "อัพโหลดเทมเพลต",
        "pass": "ผ่าน",
        "noPass": "ไม่ผ่าน",
        "revoke": "เพิกถอน",
        "deConfirm": "การป้องกันการยืนยัน",
        "submit": "ยื่น",
        "deleteSuccess": "ลบสำเร็จ",
        "saveSuccess": "บันทึกสำเร็จ",
        "saveItemTypeSuccess":"เพิ่มประเภทสินค้าเรียบร้อยแล้ว",
        "vehicleHasBeenChanged": "เปลี่ยนรถแล้ว",
        "recalculationSuccess": "การคำนวณใหม่สำเร็จ",
        "cancelled": "ยกเลิกแล้ว",
        "editSucceeded": "แก้ไขสำเร็จ",
        "relationFile": "เอกสารแนบที่เกี่ยวข้อง",
        "contractInfo": "ข้อมูลสัญญา",
        "add": "สร้าง",
        "addItem": "เพิ่ม",
        "new": "ใหม่",
        "newUpperCase": "ใหม่",
        "rename": "เปลี่ยนชื่อ",
        "modify": "ปรับปรุงใหม่  ",
        "delete": "ลบ",
        "confirm": "ยืนยัน",
        "cancel": "ยกเลิก",
        "enable": "เปิดใช้งาน",
        "disable": "ปิดใช้งาน",
        "remove": "ลบ",
        "active": "เปิดใช้งาน",
        "inactive": "ปิดการใช้งาน",
        "configure": "กำหนดค่า",
        "inputRequired": "(จำเป็น)",
        "selectRequired": "(จำเป็น)",
        "operation": "ดำเนินการ",
        "deleteTips": "ท่านแน่ใจว่าจะลบหรือไม่?",
        "deleteItemTypeTitle": "ลบประเภทสินค้า",
        "deleteItemType": "คุณแน่ใจหรือไม่ว่าต้องการลบประเภทสินค้า",
        "disableTips": "ท่านแน่ใจว่าจะปิดการใช้งานหรือไม่?",
        "tips": "ข้อเสนอแนะ",
        "operationSuccessful": "ดำเนินการสำเร็จ",
        "search": "ค้นหา",
        "save": "บันทึก",
        "preview": "ดูตัวอย่าง",
        "pleaseSelect": "กรุณาเลือก",
        "pleaseEnter": "กรุณากรอก",
        "pleaseNotOnlyOne": "กรุณาทำเครื่องหมายถูกอย่างน้อยหนึ่งรายการข้อมูล!",
        "moreShow": "ขยายตัวกรอง",
        "moreHide": "ปิดตัวกรอง",
        "maxValue": "มูลค่าสูงสุด",
        "minValue": "ขั้นต่ำ",
        "start": "เริ่ม",
        "end": "สิ้นสุด",
        "noData": "ไม่มีข้อมูล",
        "setColumn": "จัดคอลัมน์",
        "reset": "ตั้งค่าใหม่",
        "import": "นำเข้า",
        "export": "ส่งออก",
        "exportData": "นำออก",
        "exporting": "กำลังส่งออก...",
        "downloadTemplate": "ดาวน์โหลดเทมเพลต",
        "back": "กลับ",
        "return": "กลับ",
        "valueAddedServices": "รายการค่าธรรมเนียม/ส่วนลด",
        "valueAddedServices1": "รายการค่าธรรมเนียม/ส่วนลด",
        "notice": "การแจ้งเตือน",
        "remind": "แจ้งเตือน",
        "earlyWarning": "การแจ้งเตือนล่วงหน้า",
        "userName": "ชื่อผู้ใช้",
        "userID": "User ID",
        "trunkLine": "การขนส่งระหว่างคลังสินค้า",
        "dispatch": "กำหนดการ",
        "planDispatch": "วางแผนกำหนดการ",
        "pickupGoods": "รับสินค้า",
        "noPickupGoods": "ไม่รับสินค้า",
        "deliverGoods": "การจัดส่ง",
        "noDeliverGoods": "ไม่ได้จัดส่ง",
        "abnormal": "ผิดปกติ",
        "receipt": "ใบเสร็จรับเงิน",
        "receiptShipper": "ใบเสร็จรับเงินของผู้ส่งสินค้า",
        "shipper": "ผู้ส่งสินค้า",
        "receiptDriver": "ใบเสร็จรับเงินของพนักงานขับรถ",
        "driver": "พนักงานขับรถ",
        "read": "อ่านแล้ว",
        "msgInfo": "เนื้อหาข้อความ",
        "hour": "ชั่วโมง",
        "minute": "นาที",
        "second": "วินาที",
        "log": "บันทึก",
        "top": "ด้านบน",
        "bottom": "ด้านล่าง",
        "reportName": "ชื่อรายงาน",
        "date": "วันที่",
        "time": "เวลา",
        "number": "จำนวน",
        "title": "ชื่อ",
        "emailAddress": "ที่อยู่อีเมล์",
        "empty": "ไม่มีผลใช้ได้",
        "line": "เส้นทาง",
        "lng": "ลองจิจูด",
        "lat": "ละติจูด",
        "latlng": "ละติจูด, ลองจิจูด",
        "startTime": "เวลาเริ่มต้น",
        "endTime": "เวลาสิ้นสุด",
        "startTimeShip": "เวลาตั้งต้น",
        "endTimeShip": "เวลาสุดท้าย",
        "pleaseNotOnlyOneR": "กรุณาเลือกบันทึกการจัดส่ง!",
        "pleaseNotOnlyOneT": "กรุณาเลือกบันทึกคำสั่งขนส่งสินค้าอย่างน้อยหนึ่งรายการ!",
        "warning": "คำเตือน",
        "allSelect": "เลือกทั้งหมด",
        "shippingInfo": "คำแนะนำในการส่งสินค้า",
        "customerInformation": "ข้อมูลลูกค้า",
        "destinationInfo": "สถานที่ส่งสินค้า",
        "shipToInfo": "สถานที่รับสินค้า",
        "cargoInfo": "ข้อมูลสินค้า",
        "individual": "ชิ้น",
        "askEndTime": "ขอเวลาสิ้นสุด",
        "askStartTime": "ขอเวลาเริ่มต้น",
        "routeAdd": "เพิ่มไปยัง",
        "pushNew": "เพิ่มไปยัง",
        "executing": "กำลังดำเนินการ...",
        "destinationAddress": "ชื่อปลายทาง",
        "originAddress": "ชื่อต้นทาง",
        "planTransportTime": "เวลาจัดส่งตามแผน",
        "subcontractor": "ผู้รับจ้างบริการ",
        "subcontractorInformation": "ข้อมูลผู้รับจ้างบริการ",
        "downloadDocument": "ดาวน์โหลดเอกสาร",
        "shortMessage": "ข้อความสั้น",
        "receivingPlace": "สถานที่รับ",
        "deliverGoodsPlace": "สถานที่จัดส่ง",
        "saveOrder": "บันทึกคำสั่ง",
        "trackEquipment": "ตัวติดตาม",
        "abnormalTemperature": "อุณหภูมิผิดปกติ",
        "noEquipment": "ไม่มีอุปกรณ์",
        "fulload": "บรรทุกเต็มคันรถ",
        "pushMore": "เพิ่มคำสั่งใหม่",
        "receiptWay": "วิธี POD",
        "pickUpInfo": "ข้อมูลการรับสินค้า",
        "transportProcessPreview": "กระบวนการขนส่งคร่าวๆ",
        "sender": "ผู้ส่ง",
        "operationError": "การดำเนินการไม่สำเร็จ",
        "print": "พิมพ์",
        "mapTrack": "การติดตามแผนที่",
        "totalWeight": "น้ำหนักบรรจุต่อห่อ (กก.)",
        "totalVolume": "ปริมาตรรวม (ลูกบาศก์เมตร)",
        "transportVehicleInfo": "ข้อมูลรถขนส่ง",
        "sendInfo": "ข้อมูลการจัดส่ง",
        "transportNoSearch": "การสอบถามหมายเลขใบตราส่งสินค้า",
        "routeNoTrack": "การติดตามคำสั่งจัดส่ง",
        "overTemperature": "อุณหภูมิสูงเกินไป",
        "billingDetail": "ข้อมูลการเรียกเก็บเงิน",
        "close": "ปิด",
        "closedTips": "ท่านแน่ใจว่าจะปิดหรือไม่?",
        "receiverName": "ชื่อผู้รับ",
        "oAndtNo": "หมายเลขคำสั่ง",
        "transportationTrack": "หมายเลขคำสั่ง",
        "imageOrFile": "รูปภาพ/เอกสารแนบ",
        "receiptLable": "ได้รับแล้ว",
        "chooseDateTime": "เลือกวันที่&เวลา",
        "finishTime": "เวลาที่ดำเนินการแล้วเสร็จ",
        "send": "ส่ง",
        "messageContent": "เนื้อหาข้อความ",
        "optionMode": "ประเภทการส่งมอบ",
        "type": "ประเภท",
        "createSuccess": "จัดทำสำเร็จ",
        "noset": "ยังไม่ได้มอบหมาย",
        "before": "ด้านหน้า",
        "after": "ด้านหลัง",
        "continue": "ท่านต้องการดำเนินการต่อไปหรือไม่",
        "route": "คำสั่งจัดส่ง",
        "transport": "ใบตราส่งสินค้า",
        "systemMsg": "ข้อมูลระบบ",
        "selectPageStyle": "กรุณาเลือกรูปแบบสลิปกระดาษ",
        "accountRoleError": "บัญชีนี้ไม่ได้รับอนุญาตให้เข้าระบบ กรุณาล็อกอินอีกครั้ง",
        "deliveryTypeName": "รุ่นยานพาหะจัดส่งสินค้า",
        "senderAddressNum": "จำนวนต้นทาง",
        "receiverAddressNum": "สถานที่ปลายทาง",
        "need": "จำเป็น",
        "notNeed": "ไม่จำเป็น",
        "checkAccountDesc": "คำแนะนำเกี่ยวกับการกระทบยอด",
        "autoSwitchBillDate": "วันทำการของเอกสารนี้จะไม่อยู่ภายในช่วงวันที่ของใบเรียกเก็บเงิน ฉันต้องเปลี่ยนเป็นใบเรียกเก็บเงินตามรอบการเรียกเก็บเงินที่เกี่ยวข้องโดยอัตโนมัติหรือไม่",
        "selectOrgNode": "กรุณาเลือกหน่วยขององค์กร",
        "sureSave": "ท่านแน่ใจว่าต้องการบันทึกหรือไม่?",
        "selectType": "กรุณาเลือกประเภท",
        "notFixedLine": "ไม่อยู่ในเส้นที่กำหนดตายตัว",
        "addToFixedLine": "จำเป็นต้องเพิ่มสถานีเหล่านี้ในเส้นที่กำหนดตายตัวหรือไม่?",
        "electronic_receipt_attachment": "เอกสารแนบใบเสร็จรับเงินอิเลคทรอนิคส์",
        "sureAutoAdd": "การดำเนินการนี้จะรวมข้อมูลโดยอัตโนมัติภายใต้เงื่อนไขตัวกรองปัจจุบัน ท่านต้องการดำเนินการต่อไปหรือไม่?",
        "noMatchRoute": "ไม่มีรายการที่ตรงกับรายการจัดส่งที่เกี่ยวข้อง",
        "removeTransportSuccess": "ลบใบตราส่งสินค้าสำเร็จ",
        "sureAutoAddRoute": "การดำเนินการนี้จะตั้งค่าข้อมูลล่วงหน้าภายใต้เงื่อนไขตัวกรองปัจจุบันตามเส้นที่กำหนด ท่านต้องการดำเนินการต่อไปหรือไม่?",
        "selected": "ตรวจสอบแล้ว",
        "mapTips1": "ใบตราส่งสินค้าถูกแสดงตามเส้นต่างๆ: เส้นสีคือ \"จัดส่งแล้ว\" เส้นทึบสีเทาคือ \"กำหนดเวลาแล้ว\" เส้นประสีเทาคือ \"ไม่ได้กำหนดเวลา\" วงกลมหมายถึงต้นทางและปลายทางและรูปสี่เหลี่ยมหมายถึง",
        "mapTips2": "สถานที่ขนส่ง รูปสีเทา: สถานที่ที่ไม่มีใบตราส่งสินค้า รูปสี: สถานที่ที่มีใบกำกับสินค้า รูปโปร่งแสง: ไม่มีใบตราส่งสินค้า รูปทึบ: มีใบตราส่งสินค้า",
        "importAndCheck": "การนำเข้าและการกระทบยอด",
        "pleaseSelectCarType": "กรุณาเลือกรุ่นรถ!",
        "pleaseInputCarNumber": "กรุณากรอกจำนวนรถ!",
        "productServiceRequired": "สินค้า/โครงการที่ต้องการบริการ",
        "waybillNotShipped": "ยังไม่ได้ส่งใบตราส่งสินค้า!",
        "pleaseInputCurrentPassword": "กรุณากรอกรหัสผ่านปัจจุบันของท่าน",
        "pleaseInputNewPassword": "กรุณากรอกรหัสผ่านใหม่",
        "pleaseInputConfirmPassword": "กรุณากรอกรหัสผ่านยืนยัน",
        "newAndOldPasswordCannotBeSame": "รหัสผ่านเก่าและใหม่ต้องไม่ซ้ำกัน",
        "twoPasswordNotSame": "รหัสผ่านที่กรอกสองครั้งไม่ตรงกัน",
        "noFeeIdOrBillStatus": "ไม่ได้รับหมายเลขใบเรียกเก็บเงินหรือสถานะการเรียกเก็บเงิน",
        "cannotRefreshExtraCapacityAttribute": "ส่วนประกอบของขีดความสามารถเพิ่มเติมไม่สามารถรีเฟรชพร้อมกันได้",
        "cannotModify": "ไม่สามารถแก้ไขได้!",
        "productServiceMustBeService": "สินค้า/รายการต้องได้รับการบริการและไม่สามารถแก้ไขได้",
        "isLoadNextBatchData": "เลื่อนลงด้านล่าง ท่านต้องการโหลดข้อมูลชุดต่อไปหรือไม่?",
        "isLoadPreviousBatchData": "เลื่อนขึ้นด้านบน ท่านต้องการโหลดข้อมูลชุดสุดท้ายหรือไม่?",
        "reanalyzeSubmitSuccess": "ยื่นเพื่อการวิเคราะห์ใหม่สำเร็จ!",
        "completeCheckSuccess": "การกระทบยอดสำเร็จ!",
        "addPointFee": "ค่าธรรมเนียมเพิ่มเติม",
        "pickupFee": "ค่าธรรมเนียมการจัดส่ง",
        "deliveryFee": "ค่าใช้จ่ายการจัดส่ง",
        "loadingFee": "ค่าธรรมเนียมการบรรทุก",
        "unloadingFee": "ค่าธรรมเนียมการขนถ่าย",
        "emptyFee": "ค่าขนออก",
        "totalFee": "สรุปค่าธรรมเนียมทั้งหมด",
        "otherFee": "ค่าธรรมเนียมอื่นๆ",
        "waitRecive": "รอรับ",
        "transitAddress": "ที่อยู่จัดส่ง",
        "static": "คงที่",
        "basicDataLoadFail": "โหลดข้อมูลไม่สำเร็จ ดำเนินการอีกครั้งหลังจากรีเฟรช",
        "dan": "คำสั่ง",
        "car": "รถยนต์",
        "shipments": "พัสดุ",
        "vehicle": "พาหนะ",
        "homePage": "หน้าหลัก",
        "switchChangeDrag": "ลากเพื่อปรับตำแหน่ง",
        "receiptDemandDt": "วันที่รับคำร้อง",
        "cancelTransitTips": "ท่านต้องการยกเลิกการโอนส่วนงานหรือไม่?",
        "cancelBreakTips": "ยกเลิกการแยกส่วน?",
        "transportbreakTips": "ท่านแน่ใจว่าจะยกเลิกการจัดส่งหรือไม่?",
        "adjustBillingCost": "ปรับเปลี่ยนค่าธรรมเนียม",
        "workBillingCost": "ค่าธรรมเนียมที่คำนวณตามการดำเนินงาน",
        "orderBillingCost": "ค่าธรรมเนียมตามคำสั่งเดิม",
        "itemType": "ประเภทสินค้า",
        "carrierProduct": "บริการเสริม",
        "originatingSiteType": "ประเภทต้นทาง",
        "destinationSiteType": "ประเภทปลายทาง",
        "carModel": "รถยนต์รุ่น",
        "temperatureControl": "การควบคุมอุณหภูมิ",
        "weightKg": "น้ำหนัก (กิโลกรัม)",
        "waybillNumber": "หมายเลขใบตราส่งสินค้า",
        "numberOfSites": "จำนวนสถานที่",
        "unit": "หน่วย",
        "confirmed2": "ยืนยัน",
        "originInformation" : "ข้อมูลสถานที่รับสินค้า",
        "destinationInformation" : "ข้อมูลสถานที่ส่งสินค้า",
        "latitudeLongitude": "ละติจูด, ลองจิจูด",
        "addressInformation": "ข้อมูลที่อยู่",
        "originAddressInformation": "[สถานที่รับ] ข้อมูลที่อยู่",
        "destinationAddressInformation": "[สถานที่ส่ง] ข้อมูลที่อยู่",
        "originLatitudeLongitude": "[สถานที่รับ] ละติจูด, ลองจิจูด",
        "destinationLatitudeLongitude": "[สถานที่ส่ง] ละติจูด, ลองจิจูด",
        "paymentType": "ประเภทการชำระเงิน",
        "paymentChannel": "ช่องทางการชำระเงิน",
        "orderPrice": "ราคา",
        "currency": "สกุลเงิน",
        "paymentStatus": "สถานะการชำระเงิน",
        "actualOrderPrice": "ราคาจริง",
        "actualCurrency": "สกุลเงินจริง",
        "itemCategory": "ประเภทสินค้า",
        "itemUnitPrice": "ราคาสินค้า",
        "paymentDetail": "รายละเอียดการชำระเงิน",
        "actualPaymentDetail": "รายละเอียดการชำระเงินจริง",
        "damagedItem": "สินค้าที่เสียหาย",
        "enterDamagedItem": "กรอกสินค้าที่เสียหาย",
        "damagedPackage": "บรรจุภัณฑ์ที่เสียหาย",
        "enterDamagedPackage": "กรอกบรรจุภัณฑ์ที่เสียหาย",
        "rejectedItem": "สินค้าที่ถูกปฏิเสธ",
        "enterRejectedItem": "กรอกสินค้าที่ถูกปฏิเสธ",
        "rejectedPackage": "บรรจุภัณฑ์ที่ถูกปฏิเสธ",
        "enterRejectedPackage": "กรอกบรรจุภัณฑ์ที่ถูกปฏิเสธ",
        "lostItem": "สินค้าที่สูญหาย",
        "enterLostItem": "กรอกสินค้าที่สูญหาย",
        "lostPackage": "บรรจุภัณฑ์ที่สูญหาย",
        "enterLostPackage": "กรอกบรรจุภัณฑ์ที่สูญหาย",
        "attachment": "เอกสารแนบ",
        "image": "รูปภาพ",
        "proofOfPickup": "หลักฐานการรับสินค้า",
        "proofOfUnloading": "หลักฐานการโหลดสินค้าลง",
        "proofOfDelivery": "หลักฐานการส่งสินค้า",
        "imageFormat": "(ไฟล์ .jpg, .png และ .pdf)",
        "imageFormatSize": "(ไฟล์ .jpg, .png และ .pdf ขนาดสูงสุดคือ {x} MB)",
        "link": "ลิงค์",
        "downloadAll": "ดาวน์โหลดทั้งหมด",
        "remark": "หมายเหตุ",
        "writeRemark": "ระบุหมายเหตุ...",
        "staffSignature": "ลายเซ็นเจ้าหน้าที่",
        "staffName": "ชื่อเจ้าหน้าที่",
        "staffRole": "ตำแหน่งเจ้าหน้าที่",
        "latLng": "ละติจูด, ลองจิจูด",
        "information": "ข้อมูล",
        "reason": "เหตุผล",
        "enterReason": "กรอกเหตุผล",
        "selectDateTime": "เลือก วัน/เวลา",
        "uploadImage": "อัพโหลดรูปภาพ",
        "fileSizeExceed": "ขนาดของไฟล์เกินกำหนด {limit} {unit}",
        "siteId": "ไอดีพื้นที่งาน",
        "siteCode": "รหัสสถานที่",
        "siteName": "ชื่อสถานที่",
        "siteAddress": "ที่อยู่",
        "phoneNo": "หมายเลขติดต่อ",
        "accept": "ยอมรับ",
        "reject": "ปฏิเสธ",
        "default": "ตัวเลือกตั้งต้น",
        "select": "เลือก",
        "keyContactFirstName": "ชื่อผู้ติดต่อ 1",
        "keyContactLastName": "นามสกุลผู้ติดต่อ 1",
        "keyContactMobileNo": "เบอร์มือถือผู้ติดต่อ 1",
        "district": "เขต",
        "subDistrict": "แขวง",
        "province": "จังหวัด",
        "postalCode": "รหัสไปรษณีย์",
        "searchByCustomerAndSite": "ค้นหาโดยชื่อลูกค้า รหัสพื้นที่งาน ชื่อพื้นที่งาน จังหวัด",
        "enterRemark": "กรอกหมายเหต",
        "enterRemarkLimit": "กรอกหมายเหต (ใส่ได้มากสุด {n} ตัวอักษร)",
		"remarkLimitError": "หมายเหตุระบุได้มากสุด {n} ตัวอักษร หรือ น้อยกว่า",
        "noVehicle": "ไม่มีข้อมูลพาหนะ",
        "noDriver": "ไม่มีข้อมูลคนขับ",
        "bypass_status": "ปรับสถานะ",
        "the_page_will_be_refreshed_in":"รีเฟรชใน",
        "report_by_job":"รายงานตามงาน",
        "job_type":"ประเภทงาน",
        "job_created_date_time":"วัน/เวลาที่สร้างงาน",
        "target_tick_up_date_time":"วันที่/เวลาที่รับสินค้า",
        "report_by_job": "รายงานตามงาน",
        "report_by_shipment":"รายงานตามพัสดุ",
        "single_shipment": "พัสดุเดี่ยว",
        "multiple_shipment": "พัสดุหลายรายการ",
        "target_pickup_date_time": "วัน/เวลาเข้ารับ(จาก)",
        "please_click":"กด",
        "to_view_dashboard":"เพื่อดูข้อมูล Dashboard",
        "jobs": "งาน",
        "find": "ค้นหา",
        "lastUpdated": "อัปเดตครั้งล่าสุด",
        "shipmentStatus":  "สถานะพัสดุ",
        "history":  "ประวัติ",
        "importLogFilesLimit": "ข้อมูลบันทึกการนำเข้าจะไม่สามารถดูได้หลัง {x} วัน",
        "returnToShipmentStatus": "กลับไปยังสถานะพัสดุ",
        "viewImportHistory": "ดูประวัติการนำเข้า",
        "fileIsImporting": "ไฟล์กำลังนำเข้า",
        "fileIsImportingBody1": "อาจใช้เวลาในการดำเนินการสักครู่",
        "fileIsImportingBody2": "คุณสามารถตรวจสอบความคืบหน้าได้ที่รายการการนำเข้า",
        "pending": "กำลังดำเนินการ",
        "completed": "เสร็จสมบูรณ์",
        "incomplete": "ไม่สมบูรณ์",
        "partiallyCompleted": "เสร็จสมบูรณ์บางส่วน",
        "fileName": "ชื่อไฟล์",
        "importedDate": "วันที่นำเข้า",
        "importedComplete": "วันที่เสร็จ",
        "importStatus": "สถานะ",
        "action": "การกระทำ",
        "total": "ทั้งหมด",
        "errorUploadedAndSave": " รายการที่มีปัญหาจะไม่ถูกอัปโหลดและบันทึกลงในเซิร์ฟเวอร์",
        "pleaseClickToViewMapInformation":"<b style='margin-right: 2px; font-style: italic;'>กด</b>เพื่อดูข้อมูลแผนที่"
    },
    "unit": {
        "km": "กม.",
        "kg": "กก",
        "min": "นาที",
        "square": "คิวบิกเมตร",
        "box": "กล่อง",
        "gram": "กรัม",
        "jin": "ชั่ง",
        "gongjin": "กิโลกรัม",
        "ton": "ตัน",
        "gongli": "กิโลเมตร",
        "js": "ชิ้น",
        "zhan": "สถานี"
    },
    "weekObj": {
        "monday": "วันจันทร์",
        "tuesday": "วันอังคาร",
        "wednesday": "วันพุธ",
        "thursday": "วันพฤหัสบดี",
        "friday": "วันศุกร์",
        "saturday": "วันเสาร์",
        "sunday": "วันอาทิตย์",
        "week": "สัปดาห์"
    },
    "toolTip": {
        "routeCode": "รหัสเส้นทาง",
        "unit": "หน่วย",
        "actualTotalNoPackReceived": "จำนวนบรรจุภัณฑ์จริงที่ได้รับ",
        "actualTotalNoPackPaid": "จำนวนบรรจุภัณฑ์จริงที่จ่าย",
        "receivedPackingQtyTips": "กรุณากรอกจำนวนบรรจุภัณฑ์จริงที่ได้รับ",
        "paidPackingQtyTips": "กรุณากรอกจำนวนบรรจุภัณฑ์จริงที่จ่าย",
        "earliestReceivedDt": "ประมาณการณ์เวลาเข้ารับจำเป็นต้องกรอก",
        "latestReceivedDt": "ประมาณการณ์เวลานำส่งจำเป็นต้องกรอก",
        "contactMobileTips": "หมายเลขผู้ติดต่อจำเป็นต้องกรอก",
        "contactNameTips": "ชื่อผู้ติดต่อจำเป็นต้องกรอก",
        "siteNameTips": "สถานที่จำเป็นต้องกรอก",
        "provinceCityDistrictTips": "จังหวัด เมือง อำเภอ จำเป็นต้องกรอก",
        "addressTips": "ที่อยู่จำเป็นต้องกรอก",
        "sequenceTips": "รูปแบบหมายเลขการจัดลำดับไม่ถูกต้อง",
    },
    "popup": {
        "warning" : "แจ้งเตือน",
        "acknowledge": "รับทราบ",
        "userInformationHasBeenChanged": "ข้อมูลผุ้ใช้งานมีการเปลี่ยนแปลง กรุณาลงชื่อเข้าใช้งานอีกครั้ง"
    }
    ,
    "eta":{
        "viewMapDropPoint": "ดูแผนที่ / จุดรับ-ส่ง",
        "dropPoint": "จุดรับ-ส่งงาน",
        "target": "คาดการณ์",
        "targetDropStartDateTime": "วันที่/เวลาเริ่มต้นที่คาดการณ์",
        "targetDropEndDateTime": "วันที่/เวลาสิ้นสุดที่คาดการณ์",
        "estimated": "โดยประมาณ",
        "lastCalculated": "คำนวณล่าสุด : ",
        "estimatedArrivalDateTime": "วัน/เวลาที่ถึงโดยประมาณ",
        "estimatedDepartureDateTime": "วัน/เวลาที่ออกโดยประมาณ",
        "remainingDistance": "ระยะทางที่เหลือ",
        "actual": "ตามจริง",
        "actualConfidenceAndSource": "ระยะทางความเชื่อมั่น : {x}, ระยะทางที่มา : {y}",
        "actualArrivalDateTime": "วัน/เวลาที่ถึงจริง",
        "actualDepartureDateTime": "วัน/เวลาที่ออกจริง",
        "actualDistanceFromOrigin": "ระยะทางตามจริงจากจุดเริ่มต้น",
        "actualDistanceFromLastDrop": "ระยะทางตามจริงจากจุดล่าสุด",
        "planned": "ตามแผน",
        "plannedArriveDateTime": "วัน/เวลาที่ถึงตามแผน",
        "plannedDepartureDateTime": "วัน/เวลาที่ออกตามแผน",
        "plannedDistanceFromOrigin": "ระยะทางตามแผนจากจุดเริ่มต้น",
        "plannedDistanceFromLastDrop": "ระยะทางตามแผนจากจุดล่าสุด",
        "km": "กม.",
        "noMap": "ไม่มีแผนที่",
        "source":"ที่มา"
    }
}



// WEBPACK FOOTER //
// ./src/lang/th.js